import { __awaiter } from "tslib";
import React from 'react';
import ReactDOM from 'react-dom';
import { RegistrationButtonModule } from './RegistrationButtonModule';
import { buildModuleProps } from 'pathfinder/rules-engine/moduleProps';
import { getCurrentPage } from 'pathfinder/modules/RegistrationButton/utils/getCurrentPage';
import { getCommunicationService, ofType } from 'utils/communicationService';
import { AD_EVENT_SLOT_ADDED } from 'utils/communicationService/adEngineTypes';
import { CurrentPageType } from 'pathfinder/modules/RegistrationButton/types';
var CONTAINER_SELECTORS;
(function (CONTAINER_SELECTORS) {
    CONTAINER_SELECTORS["COMMUNITY_HEADER"] = ".community-header-wrapper";
    CONTAINER_SELECTORS["FC_RIGHT_RAIL"] = "#fancentralRightRail";
    CONTAINER_SELECTORS["F2_FEED_HEADER"] = ".feed-header";
    CONTAINER_SELECTORS["F2_RIGHT_RAIL"] = ".feed-layout__right-rail";
})(CONTAINER_SELECTORS || (CONTAINER_SELECTORS = {}));
const checkIfRegistrationButtonsRendered = () => {
    const registrationButtonsContainer = document.querySelector('.global-registration-buttons');
    return !!registrationButtonsContainer;
};
export const getRegistrationButtonModuleMethods = (moduleConfig) => __awaiter(void 0, void 0, void 0, function* () {
    const currentPageType = getCurrentPage();
    const moduleProps = buildModuleProps(moduleConfig, {});
    const { log } = moduleProps;
    try {
        if (checkIfRegistrationButtonsRendered()) {
            return null;
        }
        const reactRoot = document.createElement('div');
        reactRoot.classList.add('ph-registration-buttons');
        let container;
        if (currentPageType === CurrentPageType.WIKI_RELATED) {
            container = document.querySelector(CONTAINER_SELECTORS.COMMUNITY_HEADER);
            container.style.position = 'relative';
            container.insertAdjacentElement('beforeend', reactRoot);
        }
        if (currentPageType === CurrentPageType.FAN_CENTRAL) {
            container = document.querySelector(CONTAINER_SELECTORS.FC_RIGHT_RAIL);
            container.insertAdjacentElement('afterbegin', reactRoot);
        }
        if (currentPageType === CurrentPageType.F2_HOMEPAGE) {
            container = document.querySelector(CONTAINER_SELECTORS.F2_FEED_HEADER);
            container.style.position = 'relative';
            container.insertAdjacentElement('afterbegin', reactRoot);
        }
        if (currentPageType === CurrentPageType.F2_TOPIC_PAGE) {
            container = document.querySelector(CONTAINER_SELECTORS.F2_RIGHT_RAIL);
            getCommunicationService()
                .actions.pipe(ofType(AD_EVENT_SLOT_ADDED))
                .subscribe((event) => {
                if (event.name === 'top_boxad') {
                    container.insertAdjacentElement('afterbegin', reactRoot);
                }
            });
        }
        const render = () => {
            ReactDOM.render(React.createElement(RegistrationButtonModule, moduleProps), reactRoot);
            return reactRoot;
        };
        return {
            render,
        };
    }
    catch (error) {
        log.debug('RegistrationButtonModule error', error);
    }
    return null;
});
